<template>
  <div v-if="isSuperOrSalesUser" class="super-user-action-panel">
    <div class="panel-header" @click="toggle">
      <span class="panel-header__title">Shrpa admin only</span>
      <IconEmbedded :name="isExpanded ? 'caret-top_2-5' : 'caret-bottom_2-5'" :size="12" />
    </div>
    <div v-if="isExpanded" class="panel-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { useUserProfileStore } from "@stores/userProfileStore";

const STORAGE_KEY = "superUserPanelExpanded";

// Initialize from localStorage, defaulting to false if not found
const isExpanded = ref(localStorage.getItem(STORAGE_KEY) === "true");

const toggle = () => {
  isExpanded.value = !isExpanded.value;
  // Save to localStorage whenever the value changes
  localStorage.setItem(STORAGE_KEY, isExpanded.value.toString());
};

const userProfileStore = useUserProfileStore();
const isSuperOrSalesUser = computed(() => userProfileStore.isSuperOrSalesUser);
</script>

<style scoped>
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  cursor: pointer;
}

.panel-header__title {
  margin-right: 5px;
  color: grey;
  flex-grow: 1;
  text-align: right;
}

.panel-content {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
